import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';

import Copy, { CopyFormat } from 'Src/components/Copy';
import FontIcon from 'Src/components/icons/FontIcon';
import { Check } from 'Src/feature/check/models';

import styles from './CheckPanelDiscounts.module.scss';

interface CheckPanelDiscountsProps {
  check: Check | undefined;
}

const TEST_ID = {
  root: 'CheckPanelDiscounts',
};

const CheckPanelDiscounts: FC<CheckPanelDiscountsProps> = ({ check }) => {
  const { t } = useTranslation();

  if (!check?.info.discounts.length) return;

  return (
    <div data-testid={TEST_ID.root} className={styles.root}>
      {
        check?.info.discounts
          .map((disc) => {
            // only gather discounts that have been applied and not removed
            if (disc.removedAt || disc.status === 'Disabled') return;
            const { name, type, value, id } = disc;

            const formatted = {
              // TODO: calculated ( api would require large change for this to work )
              // calculated: '',
              amount: '',
            };

            if (type === 'Percent') {
              formatted.amount = CopyFormat.percent(value);
            } else {
              formatted.amount = CopyFormat.currency(value);
            }


            return (
              <div key={id} className={styles['item']}>
                <FontIcon className={styles['icon']} name="sell" size="sm" />
                <div className={styles['grid']}>
                  <Copy
                    ellipsis
                    variant="body"
                    size="lg"
                    color="textTertiary"
                    value={type === 'Amount'
                      ? t('discount.labels.currencyOffEntireOrder', { amount: formatted.amount })
                      : t('discount.labels.percentOffEntireOrder', { amount: formatted.amount })}
                  />
                  <Copy
                    // TODO: calculated ( api would require large change for this to work )
                    // type={['negative', 'currency']}
                    // value={formatted.calculated}
                    variant="body"
                    size="lg"
                    color="textTertiary"
                    align="right"
                  />
                  <Copy
                    ellipsis
                    variant="body"
                    size="lg"
                    color="textPrimary"
                    value={name}
                  />
                </div>
              </div>
            );
          })
      }
    </div>
  );
};

export { CheckPanelDiscounts, TEST_ID };
